import axios from "axios"
import router from "../router"
import qs from "qs" //qs.parse()是将URL解析成对象的形式; qs.stringify()是将对象 序列化成URL的形式，以&进行拼接
const validateStatus = (status) => {
  return status >= 200 && status < 300
}
axios.defaults.timeout = 20000
axios.defaults.withCredentials = true // 设置允许跨域设置cookie
// 开发环境下给定，生产环境删除
// axios.defaults.baseURL = window.$configUrl.baseUrl
axios.defaults.baseURL =
  process.env.NODE_ENV === "production" ? window.$configUrl.baseUrl : "/apis"
  // process.env.NODE_ENV === "production" ? window.$configUrl.baseUrl : "/apikjl"
// axios.defaults.baseURL = "http://akatsukisong.vaiwan.com/"; //线上
// axios.defaults.baseURL = 'http://192.168.4.119:9010/ubom/';  //本地
// axios.defaults.baseURL = 'http://127.0.0.1:8070/';  //本地
axios.defaults.validateStatus = validateStatus
axios.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded" //表单传值; axios.defaults.headers['Content-Type'] = 'application/json' //JSON格式
axios.defaults.headers["x-requested-with"] = "XMLHttpRequest" //null同步请求，XMLHttpRequest为Ajax请求
const pending = new Map()
const addPending = (config) => {
  const url = [config.method, config.url, qs.stringify(config.data)].join("&")
  config.cancelToken =
    config.cancelToken ||
    new axios.CancelToken((cancel) => {
      if (!pending.has(url)) {
        pending.set(url, cancel)
      }
    })
}
const removePending = (config) => {
  const url = [config.method, config.url, qs.stringify(config.data)].join("&")
  if (pending.has(url)) {
    const cancel = pending.get(url)
    // cancel('请勿重复操作~')
    pending.delete(url)
  }
}
export const clearPending = () => {
  for (const [url, cancel] of pending) {
    cancel(url)
  }
  pending.clear()
}
// http request 拦截器
axios.interceptors.request.use(
  (config) => {
    config.headers.token = localStorage.getItem("TOKEN") || ""
    // config.headers.strWebSiteId = localStorage.getItem('strWebSiteId') || '48188884340d488d9c9162c3937d161b'
    if (
      config.method === "post" &&
      config.headers["Content-Type"] == "application/x-www-form-urlencoded"
    ) {
      config.data = qs.stringify(config.data)
    }
    //发起请求时，取消掉当前正在进行的相同请求
    removePending(config)
    addPending(config)
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  (resp) => {
    removePending(resp)
    const { code, msg } = resp.data
    if (code == "402") {
      //登陆超时重新登陆
      localStorage.removeItem("TOKEN")
      localStorage.removeItem("refreshToken")
      localStorage.removeItem("userInfo")
      router.push("/home")
      return Promise.reject("登陆超时，请重新登陆~")
    }
    if (code == "401") {
      //token过期重新获取token调用之前的方法
      return axios
        .get(
          "/system/token/refresh" +
            "?refreshToken=" +
            localStorage.getItem("refreshToken")
        )
        .then((res) => {
          localStorage.setItem("TOKEN", res.data.data)
          return axios
            .request(resp.config)
            .then((resps) => {
              return resps
            })
            .catch((err) => {
              router.push("/home")
              return Promise.reject(err.msg)
            })
        })
    }
    if (!validateStatus(code) && code !== undefined) {
      //返回错误状态
      return Promise.reject(msg)
    }
    return resp
  },
  (err) => {
    if (err.message) {
      err = err.message
    }
    if (err.indexOf("Request failed with status code 500") > -1) {
      return Promise.reject("系统异常,请稍后重试~")
    }
    return Promise.reject(err)
  }
)

export default axios
